import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ClickStopPropagationDirective } from './click-stop-propagation.directive';
import { MouseOverClassDirective } from './mouse-over-class.directive';
import { TextBausteinDirective } from './text-baustein.directive';
import { TextProposalDirective } from './text-proposal.directive';
import { KieneDeNumberDirective } from './kiene-de-number.directive';
@NgModule({
    declarations: [
        TextBausteinDirective,
        TextProposalDirective,
        ClickStopPropagationDirective,

        MouseOverClassDirective,
        KieneDeNumberDirective,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDialogModule,
        MatInputModule,
        MatButtonModule,
    ],
    exports: [
        TextBausteinDirective,
        TextProposalDirective,
        ClickStopPropagationDirective,
        MouseOverClassDirective,
        KieneDeNumberDirective,
    ],
})
export class KieneDirectivesModule {}
